const returnTopRoot = document.querySelector('.returnTop');
if (returnTopRoot) {
  var target = 0,
    leader = 0,
    timer = null;
  document.onscroll = function () {
    if (scroll().top > 300) {
      returnTopRoot.style.display = "block";
      leader = scroll().top;
    } else {
      returnTopRoot.style.display = "none";
    }
  };
  returnTopRoot.addEventListener('click', () => {
    clearInterval(timer);
    var step = (target - leader) / 10;
    timer = setInterval(function () {
      step = step > 0 ? Math.ceil(step) : Math.floor(step);
      leader = leader + step;
      window.scrollTo(0, leader);
      if (leader < 64) {
        clearInterval(timer);
      }
    }, 30);
  });
}

function scroll() {
  if (window.pageYOffset != null) {
    return {
      left: window.pageXOffset,
      top: window.pageYOffset
    };
  } else if (document.compatMode == "CSS1Compat") {
    return {
      left: document.documentElement.scrollLeft,
      top: document.documentElement.scrollTop
    };
  } else {
    return {
      left: document.body.scrollLeft,
      top: document.body.scrollTop
    };
  }
}
